import React, { Component } from 'react';
import { withFirebase } from '../Firebase';
// import like_picture from "../../assets/cards/icon_card_like.svg"
// import like_icon_white from "../assets/icon_thumbs_up_checked.svg"
import like_icon_white from "../../assets/cards/like_icon_white.svg"
import like_icon from "../../assets/cards/like_icon.svg"
import Tooltip from '@material-ui/core/Tooltip';
import './LikeComponent.css';

class LikeComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { capsule: [], click: false, nbLikes: 0, likeList: [], hadLike: null, user: "", status: this.props.card, open: false }
    }

    componentWillReceiveProps(nextProp) {
        if (nextProp.idcapsule !== "") {
            let uid

            if (this.props.firebase.auth.currentUser) {
                uid = this.props.firebase.auth.currentUser.uid
                this.props.firebase.db.collection('capsules').doc(nextProp.idcapsule).get()
                    .then((doc) => {
                        this.setState({
                            capsule: doc.data(),
                            nbLikes: doc.data() ? doc.data().nbLikes : 0,
                            likeList: doc.data() ? doc.data().likeList : [],
                            hadLike: doc.data() ? doc.data().likeList.includes(uid) : false,
                            user: uid, open: true
                        });
                    })
            }
        }
    }
    addLike = () => {
        const { click, nbLikes, likeList, hadLike, user } = this.state;
        let likes = nbLikes || 0;
        if (click === false && hadLike === false) {
            likeList.push(user);
            likes += 1;
            this.setState({ click: true, nbLikes: likes, likeList })
        }
        this.props.firebase.db.collection('capsules').doc(this.props.idcapsule).set({ nbLikes: likes, likeList: likeList }, { merge: true })
    }

    render() {
        const { nbLikes, click, hadLike, status, open } = this.state
        return (
            <>
                <div hidden={open === false}>
                    <div hidden={status !== "basic"} className="basic-card-like-container">
                        <div className="btn-like" hidden={click === true || hadLike === true} onClick={this.addLike}>
                            <div className="basic-card-like-text">{nbLikes}</div>
                            <img  className="basic-card-like-icon cursor-pointer" src={like_icon} alt="Like" />
                        </div>
                        <div className="btn-like-blue" hidden={hadLike === false && click === false}>
                            <div className="basic-card-like-text-white ">{nbLikes}</div>
                            <img className="basic-card-like-icon" src={like_icon_white} alt="Like" />
                        </div>
                    </div>

                    <div hidden={status !== "active"} className="reactive-card-like-container position-like">
                        <div hidden={click === true || hadLike === true} onClick={this.addLike} className="btn-like-reactive">
                            <div className="reactive-card-like-text mr-2">{nbLikes}</div>
                            <img className="cursor-pointer" src={like_icon} alt="Like" />
                        </div>
                        <div hidden={hadLike === false && click === false} className="btn-like-blue-reactive">
                            <div className="reactive-card-like-text-white mr-2">{nbLikes}</div>
                            <img className="cursor-pointer" src={like_icon_white} alt="Like" />
                        </div>
                    </div>

                    <div hidden={status !== "challenge"} className="challenge-card-like-container">
                        <div className="btn-like" hidden={click === true || hadLike === true} onClick={this.addLike}>
                            <div className="basic-card-like-text">{nbLikes}</div>
                            <Tooltip title="Liker" aria-label="liker">
                            <img className="basic-card-like-icon cursor-pointer" src={like_icon} alt="Like" />
                            </Tooltip>
                        </div>
                        <div hidden={hadLike === false && click === false} className="btn-like-blue">
                            <div className="basic-card-like-text-white">{nbLikes}</div>
                            <img className="basic-card-like-icon cursor-pointer" src={like_icon_white} alt="Like" />
                        </div>
                    </div>

                </div>
            </>
        );
    }
}


export default withFirebase(LikeComponent);